export const DEFAULT_DECIMAL_PRECISION = 2;

export const Z_INDICES = {
  TOOLTIP: 100,
  OVERLAY: 1140,
  MODAL: 1241,
  TOP_OVERLAY: 1341,
  DD_POPPER: 1039
};

export const KEYS = {
  ENTER: 'Enter',
  SPACE: 'Space'
};

export const DEFAULT_MODULE_PAGE_SIZE = 20;

export const PERSONAL_PRONOUNS = [`Mr`, `Mrs`, `Ms`, `Miss`, `Dr`, `Bishop`, `Fr`, `Lady`, `Lord`, `Professor`, `QC`, `Rabbi`, `Rev`, `Sir`].map((item) =>
  item.toLowerCase()
);
